(function() {
        var initPhotoSwipeFromDOM = function(gallerySelector) {
            
            // Use the pre-built items array from Liquid template
            var getPhotoSwipeItems = function() {
                if (window.photoswipeItems && window.photoswipeItems.length > 0) {
                    console.log('Using pre-built PhotoSwipe items:', window.photoswipeItems.length);
                    return window.photoswipeItems;
                }
                
                // Fallback: try to parse DOM (old method)
                console.warn('PhotoSwipe items not found, falling back to DOM parsing');
                return [];
            };

            // find nearest parent element
            var closest = function closest(el, fn) {
                return el && ( fn(el) ? el : closest(el.parentNode, fn) );
            };

            var onThumbnailsClick = function(e) {
                e = e || window.event;
                e.preventDefault ? e.preventDefault() : e.returnValue = false;

                var eTarget = e.target || e.srcElement;

                var clickedListItem = closest(eTarget, function(el) {
                    return el.classList.contains('new-gallery-item');
                });

                if(!clickedListItem) {
                    return;
                }

                // Get the index from the data attribute
                var index = parseInt(clickedListItem.getAttribute('data-pswp-index'), 10);
                
                if (isNaN(index)) {
                    // Fallback: Find the index by looking at all gallery items
                    var galleryItems = document.querySelectorAll('.new-gallery-item');
                    index = -1;
                    
                    for (var i = 0; i < galleryItems.length; i++) {
                        if (galleryItems[i] === clickedListItem) {
                            index = i;
                            break;
                        }
                    }
                }

                if(index >= 0) {
                    openPhotoSwipe( index, clickedListItem.closest('.new-gallery') );
                }
                return false;
            };

            var photoswipeParseHash = function() {
                var hash = window.location.hash.substring(1),
                params = {};

                if(hash.length < 5) { // pid=1
                    return params;
                }

                var vars = hash.split('&');
                for (var i = 0; i < vars.length; i++) {
                    if(!vars[i]) {
                        continue;
                    }
                    var pair = vars[i].split('=');  
                    if(pair.length < 2) {
                        continue;
                    }           
                    params[pair[0]] = pair[1];
                }

                if(params.gid) {
                    params.gid = parseInt(params.gid, 10);
                }

                return params;
            };

            var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
                var pswpElement = document.querySelectorAll('.pswp')[0],
                    gallery,
                    options,
                    items;

                items = getPhotoSwipeItems();
                
                // If no items found, return early
                if (!items || items.length === 0) {
                    console.error('No PhotoSwipe items found');
                    return;
                }
                
                console.log('PhotoSwipe opening with', items.length, 'items');
    
                // define options (if needed)
                options = {
                    // Enable navigation arrows and controls
                    arrowEl: true,
                    preloaderEl: true,
                    counterEl: true,
                    shareEl: false,
                    fullscreenEl: true,
                    zoomEl: true,
                    
                    // Enable keyboard navigation
                    escKey: true,
                    arrowKeys: true,
                    
                    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                    getThumbBoundsFn: function(index) {
                        // Find the thumbnail element by data attribute
                        var galleryItem = document.querySelector('.new-gallery-item[data-pswp-index="' + index + '"]'),
                            thumbnail = null,
                            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                            rect;
                        
                        // Get the thumbnail image from the corresponding gallery item
                        if (galleryItem && galleryItem.children[0]) {
                            thumbnail = galleryItem.children[0];
                            rect = thumbnail.getBoundingClientRect();
                            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                        }
                        
                        // Fallback: try by index position
                        var galleryItems = document.querySelectorAll('.new-gallery-item');
                        if (galleryItems[index] && galleryItems[index].children[0]) {
                            thumbnail = galleryItems[index].children[0];
                            rect = thumbnail.getBoundingClientRect();
                            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                        }
                        
                        // Final fallback: return center of screen
                        return {x: window.innerWidth/2, y: window.innerHeight/2, w: 1};
                    },

                    /*
                    addCaptionHTMLFn: function(item, captionEl, isFake) {
                        if(!item.title) {
                            captionEl.children[0].innerText = '';
                            return false;
                        }
                        captionEl.children[0].innerHTML = item.title +  '<br/><small>Photo: ' + item.author + '</small>';
                        return true;
                    } */
                    
                };


                if(fromURL) {
                    if(options.galleryPIDs) {
                        // parse real index when custom PIDs are used 
                        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                        for(var j = 0; j < items.length; j++) {
                            if(items[j].pid == index) {
                                options.index = j;
                                break;
                            }
                        }
                    } else {
                        options.index = parseInt(index, 10) - 1;
                    }
                } else {
                    options.index = parseInt(index, 10);
                }

                // exit if index not found
                if( isNaN(options.index) ) {
                    return;
                }



                var radios = document.getElementsByName('gallery-style');
                var radioFound = false;
                for (var i = 0, length = radios.length; i < length; i++) {
                    if (radios[i].checked) {
                        radioFound = true;
                        if(radios[i].id == 'radio-all-controls') {
                            // Keep all controls enabled (already set above)
                        } else if(radios[i].id == 'radio-minimal-black') {
                            options.mainClass = 'pswp--minimal--dark';
                            options.barsSize = {top:0,bottom:0};
                            options.captionEl = false;
                            options.shareEl = false;
                            options.bgOpacity = 0.85;
                            options.tapToClose = true;
                            options.tapToToggleControls = true;
                            // Keep navigation arrows enabled
                            options.arrowEl = true;
                            options.fullscreenEl = true;
                        }
                        break;
                    }
                }
                
                // Fallback: If no radio buttons found, ensure navigation is enabled
                if (!radioFound) {
                    options.arrowEl = true;
                    options.fullscreenEl = true;
                    options.tapToToggleControls = true;
                }

                if(disableAnimation) {
                    options.showAnimationDuration = 0;
                }

                // Pass data to PhotoSwipe and initialize it
                gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);

                // see: http://photoswipe.com/documentation/responsive-images.html
                var realViewportWidth,
                    useLargeImages = false,
                    firstResize = true,
                    imageSrcWillChange;

                gallery.listen('beforeResize', function() {

                    var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
                    dpiRatio = Math.min(dpiRatio, 2.5);
                    realViewportWidth = gallery.viewportSize.x * dpiRatio;


                    if(realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200 ) {
                        if(!useLargeImages) {
                            useLargeImages = true;
                            imageSrcWillChange = true;
                        }
                        
                    } else {
                        if(useLargeImages) {
                            useLargeImages = false;
                            imageSrcWillChange = true;
                        }
                    }

                    if(imageSrcWillChange && !firstResize) {
                        gallery.invalidateCurrItems();
                    }

                    if(firstResize) {
                        firstResize = false;
                    }

                    imageSrcWillChange = false;

                });

                gallery.listen('gettingData', function(index, item) {
                    if( useLargeImages ) {
                        item.src = item.o.src;
                        item.w = item.o.w;
                        item.h = item.o.h;
                    } else {
                        item.src = item.m.src;
                        item.w = item.m.w;
                        item.h = item.m.h;
                    }
                });

                gallery.init();
            };

            // select all gallery elements
            var galleryElements = document.querySelectorAll( gallerySelector );
            
            for(var i = 0, l = galleryElements.length; i < l; i++) {
                galleryElements[i].setAttribute('data-pswp-uid', i+1);
                galleryElements[i].onclick = onThumbnailsClick;
            }

            // Parse URL and open gallery if it contains #&pid=3&gid=1
            var hashData = photoswipeParseHash();
            if(hashData.pid && hashData.gid) {
                openPhotoSwipe( hashData.pid,  galleryElements[ hashData.gid - 1 ], true, true );
            }
        };
        
        // Wait for DOM to be fully loaded before initializing PhotoSwipe
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                // Add a small delay to ensure Swiper and photoswipeItems are ready
                setTimeout(function() {
                    initPhotoSwipeFromDOM('.new-gallery');
                }, 1000);
            });
        } else {
            // Add a small delay to ensure Swiper and photoswipeItems are ready
            setTimeout(function() {
                initPhotoSwipeFromDOM('.new-gallery');
            }, 1000);
        }
  
  		// initPhotoSwipeFromDOM('.product__mobile_images .slick_slider');

    })();